/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Createdperson1Inputs */

const de__field_createdperson1 = /** @type {(inputs: _Field_Createdperson1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angelegt von`)
};

/**

* @param {_Field_Createdperson1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_createdperson1 = /** @type {((inputs?: _Field_Createdperson1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Createdperson1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_createdperson1(inputs)
});
export { _field_createdperson1 as "_field_createdPerson" }